import { E_QUERY_ITEM_CONDITION, I18nLang, IQuery, IQueryItem } from '@patsnap/synapse_common_interface'
import { E_QUERY_ITEM_TYPE, IBAcTag, IListItem } from '@pharmsnap/shared/types'

export function checkExist(items: IBAcTag[], item: IListItem, isCN: boolean) {
  return items.find((tag) => {
    if (item.id) {
      return tag.id === item.id
    } else {
      if (tag.id) return false
      return isCN ? tag.display_name_cn === item.display_name_cn : tag.display_name_en === item.display_name_en
    }
  })
}

/**
 * 从源过滤掉指定的tag
 * @param originalTags
 * @param removeItem
 * @param isCN
 * @returns
 */
export function getRemoveResult(originalTags: IBAcTag[], removeItem: IBAcTag, isCN: boolean) {
  if (removeItem.id) {
    return originalTags.filter((o) => o.id !== removeItem.id)
  } else {
    return originalTags.filter(
      (o) => o.id || (isCN ? o.display_name_cn !== removeItem.display_name_cn : o.display_name_en !== removeItem.display_name_en)
    )
  }
}

/**
 * 判断是否是一个带query的tag
 * @param item
 * @returns
 */
export function isStringQueryItem(item: IBAcTag | string): boolean {
  return typeof item !== 'string' && !!item.searchQuery
}

/**
 * syntaxTree返回的query是不带fields的，这边要递归把fields插上去
 * @param query
 * @param fields
 */
export function transDefaultSyntaxTreeQuery(query: IQuery, fields: string[] = ['ALL_FIELDS']) {
  const arr = [...(query.must || []), ...(query.any || [])]
  arr.forEach((item) => {
    if ('fields' in item) {
      item.fields = fields
    }
    if (item.type === 'group') {
      transDefaultSyntaxTreeQuery(item, fields)
    }
  })
}

export function transSmartSearchText2QueryItem(text: string) {
  const queryText = text
  const mustItem: IQueryItem = {
    condition: E_QUERY_ITEM_CONDITION.ANY,
    type: E_QUERY_ITEM_TYPE.FIELD,
    fields: ['ALL_FIELDS'],
    value: [
      {
        display_name_cn: queryText,
        display_name_en: queryText,
        type: 'text',
        value: queryText,
      },
    ],
  }
  return mustItem
}

// 将All类型的query数据转化成智能检索的数据
export function transAllDataTypeQueryItems2SmartSearchData(mustItems: IQueryItem[], locale: I18nLang) {
  // items 中应该只有一个数据，里面的value可能多个（All 检索的时候，限定了需要输入相同类型的实体）
  const queryData: {
    queryText: string
  } = {
    queryText: '',
  }
  // ALL 检索类型情况下，mustItems 内部只有一个元素，且里面的value类型相同，不会有不同实体类型的情况
  if (mustItems.length !== 1) return queryData

  const firstMustItem = mustItems[0]

  if (firstMustItem.type !== 'field') return queryData

  if (firstMustItem.value.length === 0) return queryData

  const queryValue = firstMustItem.value[0]
  const validTypes: Array<typeof queryValue['type']> = ['drug', 'disease', 'drugType', 'target', 'organization']
  if (firstMustItem.value.length === 1) {
    if (validTypes.includes(queryValue.type)) {
      queryData.queryText = locale === 'cn' ? queryValue.display_name_cn || '' : queryValue.display_name_en || ''
    } else {
      queryData.queryText = locale === 'cn' ? queryValue.display_name_cn || '' : queryValue.display_name_en || ''
    }
  }

  if (firstMustItem.value.length > 1) {
    const queryValues = firstMustItem.value
    const texts: string[] = []

    queryValues.forEach((item) => {
      texts.push(locale === 'cn' ? item.display_name_cn || '' : item.display_name_en || '')
    })

    if (texts.length) {
      queryData.queryText = texts.map((i) => `"${i}"`).join(' OR ')
    }
  }

  return queryData
}

// 将智能检索的数据转化成All类型的query数据
export function transSmartSearchData2AllDataTypeQueryItem(data: { queryTags: string[] }) {
  const { queryTags } = data
  const mustItem: IQueryItem = {
    condition: E_QUERY_ITEM_CONDITION.ANY,
    type: E_QUERY_ITEM_TYPE.FIELD,
    fields: ['ALL_FIELDS'],
    value: queryTags.map((text) => ({
      display_name_cn: text,
      display_name_en: text,
      type: 'text',
      value: text,
    })),
  }
  return mustItem
}
